const MarkdownLinkRegex = /\[([^\]]+)?\]\((?!javascript:.+)([^\)]+)?\)/gi;

export default MarkdownLinkRegex;
